import {WellnessCarouselType} from "@irati/types"
import Link, {RouterLink} from "@irati/ui/src/Link"
import React from "react"

type Props = {
  url: string
  onClick: () => void
  ctaType: WellnessCarouselType
}

const MediaLink: React.FC<Props> = ({ctaType, url, onClick, children}) =>
  ctaType === "external" ? (
    <Link href={url} onClick={onClick} target="_blank">
      {children}
    </Link>
  ) : (
    <RouterLink to={url} onClick={onClick}>
      {children}
    </RouterLink>
  )

export default MediaLink
